<script setup lang="ts">
/**
 * "New Version" in the bottom left corner once a newer release of BOB is out
 * (plugins/new-release.client.ts). BOB takes it by itself at a safe moment; Reload is for whoever
 * wants it now. Nothing else is drawn until then.
 */
const newRelease = useState('new-release', () => false)
const reload = () => window.location.reload()
</script>

<template>
  <div
    v-if="newRelease"
    class="dock-theme fixed bottom-4 left-4 z-[250] max-w-[calc(100vw-2rem)]"
    role="status"
    data-testid="new-release"
  >
    <div class="dk-surface dk-line flex items-center gap-3 border px-3 py-2">
      <span class="text-sm font-semibold text-foreground-primary">New Version</span>
      <button type="button" class="dk-btn dk-btn-sm" title="Load the new version of BOB now" @click="reload">
        Reload
      </button>
    </div>
  </div>
</template>
